<template>
  <div class="full d-flex justify-center">
    <div class="breakpoint d-flex align-center justify-center purple-bg">
      <div class="text-center white--text intro">
        <p>Selamat datang di <b>The Journey</b></p>
        <p>
          Mulailah perjalananmu dalam mengenali diri dengan mengikuti berbagai
          tes yang tentu saja dapat diakses dengan <b>gratis!</b>
        </p>
        <p>
          Dapatkan juga hasil tes dan poin setiap selesai mengikuti tiap
          journey.
        </p>
        <p>Yuk, mulai perjalanan dengan menekan gambar kado di bawah ini!</p>
        <div class="pointer">
          <router-link to="/journey/roadmap">
            <img
              src="../assets/img/Journey 2 Kado Gif-Dark Purple.gif"
              height="130px"
              alt=""
            />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>
